import React, { FunctionComponent, useMemo, useEffect } from "react";
import { ScaleControl } from "mapbox-gl";

import useMap from "./use-map";
import useDeepCompare from "@alpaca-travel/utils/use-deep-compare";

const MapScaleControl: FunctionComponent<MapScaleControlProps> = ({
  maxWidth = 100,
  unit = "metric",
  position = "bottom-right",
}) => {
  // Update options
  const options = useMemo(
    () => ({
      maxWidth,
      unit,
    }),
    [maxWidth, unit]
  );
  const latestOptions = useDeepCompare(options);

  // Obtain the map
  const { map } = useMap();

  // Add the control
  useEffect(() => {
    if (map) {
      // Add in the control
      const control = new ScaleControl(latestOptions);
      map.addControl(control, position);

      return () => {
        // Remove when component is unmounted
        map.removeControl(control);
      };
    }
  }, [map, latestOptions, position]);

  return null;
};

export default React.memo(MapScaleControl);

type MapScaleControlProps = {
  maxWidth?: number;
  unit?: "metric" | "imperial" | "nautical";
  position?: "top-right" | "top-left" | "bottom-right" | "bottom-left";
};
